import styled, { css } from "styled-components";
import { color, typeStyle, units, visuallyHidden } from "@m/alchemy-theme";
export const CharacterCountWrapper = styled.footer `
  text-align: right;
  padding: ${units(0.5)} ${units(2)} ${units(1)};
  ${typeStyle("captionM")}
  color: ${({ isValid }) => (isValid ? color("typeMeta") : color("base", { palette: "expressiveNegative" }))};
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  pointer-events: none;

  ${({ isRelativeToParent, offsetRight = "0" }) => isRelativeToParent &&
    css `
      position: absolute;
      bottom: 0;
      right: ${offsetRight};
    `}
`;
export const ScreenReaderCharacterCount = styled.span `
  ${visuallyHidden()};
`;
